import React from 'react';
import ReactDOM from 'react-dom';
import NationalitySelect from './nationality_select';
import {
  handleChangeEvent,
  updateGenderOptions,
  storeSelectedValues,
  setStepOneHistoryValues,
  handleNumberOfSeekersChange,
} from './wanted_ad/room_and_gender_fields';
import trackingStepBack from './tracking_back_link_mobile.js';
import storageAvailable from '../../helpers/storage_available';

trackingStepBack();

const createNationalitySelect = () => {
  const mountElement = document.getElementById('nationality-select');
  if (mountElement) {
    const { selected } = mountElement.dataset;
    ReactDOM.render(<NationalitySelect selected={selected} />, mountElement);
  }
};

createNationalitySelect();

// Step 1 and edit ad room and gender set up
const whoIsSearching = document.querySelectorAll(
  'input[name="who_is_searching"]',
);
const stepOneForm = document.getElementsByName('place_room_wanted_st_1')[0];
const chromeBrowser =
  window.navigator.userAgent.toLowerCase().indexOf('chrome') > -1 &&
  !!window.chrome;

if (whoIsSearching.length > 0) {
  whoIsSearching.forEach((input) =>
    input.addEventListener('click', handleChangeEvent),
  );
  updateGenderOptions();
}

// Step 2 reload form if number of seekers changes
const initialNumAndGender = document.getElementsByName(
  'prev_NumberAndSexOfSeekers',
)[0];

if (initialNumAndGender) {
  const genderButtons = document.getElementsByName('NumberAndSexOfSeekers');
  genderButtons.forEach((button) =>
    button.addEventListener('click', handleNumberOfSeekersChange),
  );
}

/** Store selected gender for Chrome back button */
/** Chrome not retaining gender value fix */
if (chromeBrowser && stepOneForm && storageAvailable('sessionStorage')) {
  storeSelectedValues();
  setStepOneHistoryValues();
}
